// Angular
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
// CRUD
import { QueryResultsModel } from '../models/query-models/query-results.model';
import { QueryParamsModel } from '../models/query-models/query-params.model';
import { HttpExtenstionsModel } from '../../crud/models/http-extentsions-model';

@Injectable()
export class HttpUtilsService {
  /**
   * Prepare query http params
   * @param queryParams: QueryParamsModel
   */
  getFindHTTPParams(queryParams): HttpParams {
    let params = new HttpParams();
    params = params.append('sort', queryParams.sortField + ',' + queryParams.sortOrder);
    params = params.append('page', queryParams.pageNumber.toString());
    params = params.append('size', queryParams.pageSize.toString());
    if (!queryParams.filter) {
      return params;
    }
    const filter = queryParams.filter;
    for (const f in filter) {
      params = params.append(f, filter[f]);
    }
    return params;
  }

  /**
   * get standard content-type
   */
  getHTTPHeaders(authToken?: string, impersonatedId?: number): HttpHeaders {
    let result = new HttpHeaders().set('Content-Type', 'application/json');
    if (authToken) {
      result = result.set('Authorization', 'Bearer ' + authToken);
    }
    if (impersonatedId) {
      result = result.set('Impersonated-User-Id', impersonatedId.toString());
    } else {
      result = result.set('Content-Type', 'application/json');
    }
    return result;
  }

  getHTTPHeadersformCSV(authToken?: string): HttpHeaders {
    let result;
    if (authToken) {
      result = new HttpHeaders().set('Authorization', 'Bearer ' + authToken);
    } else {
      result = new HttpHeaders();
    }
    return result;
  }

  getHTTPHeadersqv(authToken?: string): HttpHeaders {
    let result;
    if (authToken) {
      result = new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('Authorization', authToken)
        .set('Origin', '*');
    } else {
      result = new HttpHeaders().set('Content-Type', 'application/json');
    }
    return result;
  }

  baseFilter(
    entities: any[],
    queryParams: QueryParamsModel,
    filtrationFields: string[] = [],
  ): QueryResultsModel {
    const httpExtension = new HttpExtenstionsModel();
    return httpExtension.baseFilter(entities, queryParams, filtrationFields);
  }

  sortArray(incomingArray: any[], sortField = '', sortOrder = 'asc'): any[] {
    const httpExtension = new HttpExtenstionsModel();
    return httpExtension.sortArray(incomingArray, sortField, sortOrder);
  }

  searchInArray(incomingArray: any[], queryObj: any, filtrationFields: string[] = []): any[] {
    const httpExtension = new HttpExtenstionsModel();
    return httpExtension.searchInArray(incomingArray, queryObj, filtrationFields);
  }
}
